import ModalFactory from '@/utils/modalFactory';
import MultiConflictsModal from './MultiConflictsModal';
const multiConflictModal = ModalFactory(MultiConflictsModal);
export const openMultiConflictModal = async (options) => await multiConflictModal(options);
